import { render } from "./SeStdTaxForm4684.vue?vue&type=template&id=9664c32e"
import script from "./SeStdTaxForm4684.vue?vue&type=script&lang=js"
export * from "./SeStdTaxForm4684.vue?vue&type=script&lang=js"

import "./SeStdTaxForm4684.vue?vue&type=style&index=0&id=9664c32e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__